import React from 'react';
import './FusionChamberAnimation.css';

// Static candy logo URLs (served from public/images/candies/)
const SlapTaffyUnhinged = '/images/candies/slaptaffy_unhinged.jpg';
const ShaftBerryGoldMember = '/images/candies/shaftberry_goldmember.jpg';

/**
 * FusionChamberAnimation Component
 * Shows two candies spiraling towards center, fusing with explosion effect,
 * then revealing a mystery "?" symbol
 */
const FusionChamberAnimation = () => {
    return (
        <div className="fusion-animation-container">
            {/* Background energy field */}
            <div className="fusion-energy-field" />

            {/* Orbiting rings */}
            <div className="fusion-orbits">
                <span className="orbit orbit-1" />
                <span className="orbit orbit-2" />
                <span className="orbit orbit-3" />
            </div>

            {/* Orbiting candy 1 - SlapTaffy Unhinged */}
            <div className="fusion-candy candy-1">
                <img src={SlapTaffyUnhinged} alt="SlapTaffy" />
            </div>

            {/* Orbiting candy 2 - ShaftBerry GoldMember */}
            <div className="fusion-candy candy-2">
                <img src={ShaftBerryGoldMember} alt="ShaftBerry" />
            </div>

            {/* Fusion point with sparkle explosion */}
            <div className="fusion-chamber-core">
                {/* Sparkle particles */}
                <div className="fusion-sparkles">
                    <span className="sparkle s1" />
                    <span className="sparkle s2" />
                    <span className="sparkle s3" />
                    <span className="sparkle s4" />
                    <span className="sparkle s5" />
                    <span className="sparkle s6" />
                    <span className="sparkle s7" />
                    <span className="sparkle s8" />
                    <span className="sparkle s9" />
                    <span className="sparkle s10" />
                    <span className="sparkle s11" />
                    <span className="sparkle s12" />
                </div>
                {/* Mystery result */}
                <div className="fusion-chamber-result">
                    <div className="fusion-result-card">
                        <span className="mystery-symbol">?</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FusionChamberAnimation;
